import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Wrench, Facebook, Twitter, Instagram, Linkedin, ShieldCheck, BadgeCheck, RefreshCw, CreditCard, Headphones } from "lucide-react";

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-[#202124] text-white" data-testid="footer">
      <div className="container-custom py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-[#1a73e8] flex items-center justify-center">
                <Wrench className="w-5 h-5 text-white" />
              </div>
              <span className="font-semibold text-xl">LocalPros</span>
            </Link>
            <p className="text-gray-400 text-sm">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium mb-4">{t("footer.forCustomers")}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/browse" className="hover:text-white transition-colors">
                  {t("footer.findPros")}
                </Link>
              </li>
              <li>
                <Link to="/request" className="hover:text-white transition-colors">
                  {t("footer.requestService")}
                </Link>
              </li>
              <li>
                <Link to="/#how-it-works-section" className="hover:text-white transition-colors">
                  {t("footer.howItWorks")}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-white transition-colors">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          {/* Pro Links */}
          <div>
            <h4 className="font-medium mb-4">{t("footer.forPros")}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/join" className="hover:text-white transition-colors">
                  {t("footer.joinAsPro")}
                </Link>
              </li>
              <li>
                <Link to="/leads" className="hover:text-white transition-colors">
                  {t("footer.proResources")}
                </Link>
              </li>
              <li>
                <Link to="/#success-stories-section" className="hover:text-white transition-colors">
                  {t("footer.successStories")}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-white transition-colors">
                  {t("footer.proSupport")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-medium mb-4">{t("forms.service")}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/browse?service=plumbing" className="hover:text-white transition-colors">
                  {t("categories.plumbing")}
                </Link>
              </li>
              <li>
                <Link to="/browse?service=electrical" className="hover:text-white transition-colors">
                  {t("categories.electrical")}
                </Link>
              </li>
              <li>
                <Link to="/browse?service=hvac" className="hover:text-white transition-colors">
                  {t("categories.hvac")}
                </Link>
              </li>
              <li>
                <Link to="/browse?service=handyman" className="hover:text-white transition-colors">
                  {t("categories.handyman")}
                </Link>
              </li>
              <li>
                <Link to="/browse?service=cleaning" className="hover:text-white transition-colors">
                  {t("categories.cleaning")}
                </Link>
              </li>
              <li>
                <Link to="/browse?service=mechanics" className="hover:text-white transition-colors">
                  {t("categories.mechanics")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="border-t border-gray-800 mt-10 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-6 text-gray-400">
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4" />
              <span className="text-xs">SSL Secured</span>
            </div>
            <div className="flex items-center gap-2">
              <BadgeCheck className="w-4 h-4" />
              <span className="text-xs">Verified Pros</span>
            </div>
            <div className="flex items-center gap-2">
              <RefreshCw className="w-4 h-4" />
              <span className="text-xs">Money Back Guarantee</span>
            </div>
            <div className="flex items-center gap-2">
              <CreditCard className="w-4 h-4" />
              <span className="text-xs">Secure Payments</span>
            </div>
            <div className="flex items-center gap-2">
              <Headphones className="w-4 h-4" />
              <span className="text-xs">24/7 Support</span>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>
          
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <Twitter className="w-5 h-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <Linkedin className="w-5 h-5" />
            </a>
          </div>

          <div className="flex items-center gap-4 text-sm text-gray-400">
            <a href="#" className="hover:text-white transition-colors">
              {t("footer.privacy")}
            </a>
            <a href="#" className="hover:text-white transition-colors">
              {t("footer.terms")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
